import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import logoIUH from "../../image/Logo_IUH.png";
import "./AboutPage.css";

function AboutPage() {
  const navigate = useNavigate();

  return (
    <div className="about-page py-4">
      <Container>
        {/* Hero Section */}
        <div className="about-hero mb-5">
          <Row className="align-items-center">
            <Col lg={8}>
              <div className="hero-badge mb-3">
                <i className="bi bi-shield-check"></i>
                Hệ Thống Bãi Đỗ Xe Thông Minh
              </div>
              <h1 className="mb-3">IUH Parking</h1>
              <p className="lead mb-4">
                Giải pháp giữ xe thông minh tự động hóa toàn diện, kết hợp trí tuệ nhân tạo (AI) nhận diện biển số, công nghệ thẻ RFID và ví điện tử không dùng tiền mặt dành riêng cho Trường Đại học Công nghiệp TP.HCM.
              </p>
              <div className="d-flex gap-3 flex-wrap">
                <Button
                  variant="light"
                  size="lg"
                  className="rounded-3 px-4 fw-bold text-primary shadow-sm"
                  onClick={() => navigate("/user/register-vehicle")}
                >
                  <i className="bi bi-plus-circle me-2"></i>Đăng ký phương tiện
                </Button>
                <Button
                  variant="outline-light"
                  size="lg"
                  className="rounded-3 px-4 fw-semibold"
                  onClick={() => navigate("/user/ewalletInfo")}
                >
                  <i className="bi bi-wallet2 me-2"></i>Ví IUH Parking Pay
                </Button>
              </div>
            </Col>
            <Col lg={4} className="text-center d-none d-lg-block">
              <div className="p-4 bg-white rounded-4 shadow-lg d-inline-block text-center" style={{ maxWidth: '240px' }}>
                <img
                  src={logoIUH}
                  alt="IUH Logo"
                  className="w-100"
                  style={{ height: "130px", objectFit: "contain" }}
                />
              </div>
            </Col>
          </Row>
        </div>

        {/* Feature Stats */}
        <Row className="g-4 mb-5">
          {[
            {
              icon: "bi-lightning-charge-fill",
              color: "#3b82f6",
              bg: "#eff6ff",
              title: "Tốc Độ Xử Lý < 2 Giây",
              desc: "Nhận diện biển số xe tự động và mở barie tức thì, loại bỏ tình trạng ùn tắc giờ cao điểm."
            },
            {
              icon: "bi-shield-lock-fill",
              color: "#10b981",
              bg: "#ecfdf5",
              title: "An Ninh 2 Lớp Khép Kín",
              desc: "Đối chiếu đồng thời biển số xe, ảnh thẻ từ RFID và xác thực sinh trắc học khuôn mặt AI."
            },
            {
              icon: "bi-wallet-fill",
              color: "#8b5cf6",
              bg: "#f5f3ff",
              title: "Thanh Toán Tự Động",
              desc: "Tích hợp ví điện tử IUH Parking Pay, tự động trừ tiền vé chính xác khi xe qua cổng ra."
            },
            {
              icon: "bi-phone-fill",
              color: "#f59e0b",
              bg: "#fffbeb",
              title: "Quản Lý 100% Online",
              desc: "Dễ dàng đăng ký xe, nạp tiền ví và tra cứu lịch sử gửi xe mọi lúc mọi nơi trên điện thoại."
            }
          ].map((item, idx) => (
            <Col key={idx} md={6} lg={3}>
              <div className="stat-card">
                <div className="icon-wrapper" style={{ background: item.bg, color: item.color }}>
                  <i className={`bi ${item.icon}`}></i>
                </div>
                <h5 className="fw-bold text-dark mb-2">{item.title}</h5>
                <p className="text-muted small mb-0">{item.desc}</p>
              </div>
            </Col>
          ))}
        </Row>

        {/* Công Nghệ Nổi Bật */}
        <div className="mb-5">
          <div className="text-center mb-4">
            <h2 className="fw-bold text-dark mb-2">Công Nghệ Nổi Bật Sáng Tạo</h2>
            <p className="text-muted">Ứng dụng các công nghệ tiên tiến nhất mang lại trải nghiệm gửi xe an tâm & hiện đại</p>
          </div>
          <Row className="g-4">
            <Col md={6}>
              <div className="tech-card">
                <div className="d-flex align-items-center gap-3 mb-3">
                  <div className="p-3 bg-primary bg-opacity-10 text-primary rounded-3">
                    <i className="bi bi-eye-fill fs-3"></i>
                  </div>
                  <div>
                    <h5 className="fw-bold text-dark mb-0">AI Computer Vision (Nhận diện Biển số)</h5>
                    <span className="text-muted small">Mô hình AI xử lý hình ảnh camera tốc độ cao</span>
                  </div>
                </div>
                <p className="text-muted mb-0">
                  Hệ thống sử dụng các thuật toán Deep Learning nhận dạng ký tự biển số chính xác trên 98%, hoạt động tốt trong mọi điều kiện ánh sáng ngày & đêm.
                </p>
              </div>
            </Col>

            <Col md={6}>
              <div className="tech-card">
                <div className="d-flex align-items-center gap-3 mb-3">
                  <div className="p-3 bg-success bg-opacity-10 text-success rounded-3">
                    <i className="bi bi-credit-card-2-front-fill fs-3"></i>
                  </div>
                  <div>
                    <h5 className="fw-bold text-dark mb-0">Thẻ Từ RFID & AI Face Recognition</h5>
                    <span className="text-muted small">Xác thực người dùng đa tầng an toàn</span>
                  </div>
                </div>
                <p className="text-muted mb-0">
                  Kết hợp giữa thẻ từ RFID tần số cao và công nghệ sinh trắc học khuôn mặt AI giúp đảm bảo người ra và người vào trùng khớp tuyệt đối.
                </p>
              </div>
            </Col>
          </Row>
        </div>

        {/* Quy trình gửi xe 3 bước */}
        <div className="mb-5">
          <div className="text-center mb-4">
            <h2 className="fw-bold text-dark mb-2">Quy Trình Gửi Xe 3 Bước Đơn Giản</h2>
            <p className="text-muted">Nhanh chóng, tiện lợi cho sinh viên & cán bộ nhân viên IUH</p>
          </div>
          <Row className="g-4">
            <Col md={4}>
              <div className="step-card">
                <div className="step-number">1</div>
                <h5 className="fw-bold text-dark mb-2">Cổng Vào (Check-in)</h5>
                <p className="text-muted small mb-0">
                  Di chuyển xe vào làn. Camera AI tự động chụp ảnh biển số và quẹt thẻ RFID / Quét khuôn mặt để xác thực vào bãi.
                </p>
              </div>
            </Col>

            <Col md={4}>
              <div className="step-card">
                <div className="step-number">2</div>
                <h5 className="fw-bold text-dark mb-2">Đỗ Xe Tại Bãi</h5>
                <p className="text-muted small mb-0">
                  Đỗ xe vào vị trí theo sự hướng dẫn của bảng điện tử và nhân viên bảo vệ. Xe được giám sát camera AI 24/7.
                </p>
              </div>
            </Col>

            <Col md={4}>
              <div className="step-card">
                <div className="step-number">3</div>
                <h5 className="fw-bold text-dark mb-2">Cổng Ra (Check-out)</h5>
                <p className="text-muted small mb-0">
                  Quẹt thẻ tại cổng ra. Hệ thống tự động kiểm tra khớp biển số và tự động trừ phí từ ví điện tử IUH Parking Pay.
                </p>
              </div>
            </Col>
          </Row>
        </div>

        {/* Contact Info Box */}
        <div className="contact-box text-center">
          <h3 className="fw-bold text-dark mb-2">Ban Quản Lý Bãi Đỗ Xe IUH Parking</h3>
          <p className="text-muted mb-4 mx-auto" style={{ maxWidth: "600px" }}>
            Trường Đại học Công nghiệp TP.HCM — 12 Nguyễn Văn Bảo, Phường Hạnh Thông, TP. Hồ Chí Minh
          </p>
          <div className="d-flex justify-content-center gap-4 flex-wrap text-dark fw-semibold">
            <div><i className="bi bi-telephone-fill text-primary me-2"></i>0283.8940 390 - ext 838</div>
            <div><i className="bi bi-envelope-fill text-primary me-2"></i>csm@iuh.edu.vn</div>
            <div><i className="bi bi-clock-fill text-primary me-2"></i>Hoạt động: 06:00 - 23:00 hàng ngày</div>
          </div>
        </div>
      </Container>
    </div>
  );
}

export default AboutPage;
